import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const BottomFooter = () => {
    const { t } = useTranslation();
    
    return (
        <div className="bottom-footer bg-color-one py-4">
            <div className="container container-lg">
                <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
                    <p className="bottom-footer__text ">
                        {t("copyright")}
                    </p>
                    <p className="bottom-footer__text ">
                        {t("designedBy")} <Link className='text-main' to="https://www.upwork.com/agencies/1782077553607639040/">{t("companyName")}</Link>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BottomFooter